



































































































import { mapGetters } from 'vuex';

export default {
	name: 'Navbar',

	data() {
		return {
			notificationCheckTimer: null,
		};
	},

	computed: {
		userInitials() {
			return this.$auth.loggedIn
				? `${this.$auth.user.name[0]}${this.$auth.user.surname[0]}`
				: '';
		},

		hasUnreadNotifications() {
			return this.$store.getters[
				'notifications/notification/getUnreadBoolean'
			];
		},

		hasUnreadMessages() {
			return this.$store.getters['conversations/getHasUnreadMessages'];
		},

		tabs() {
			let arr = [
				{
					icon: 'home-filled-icon',
					text: 'All Jobs',
					path: '/jobs',
					active:
						this.$route.path === this.localePath({ path: '/jobs' }),
				},
				{
					icon: 'job-filled-icon',
					text: 'My Jobs',
					path: '/my-jobs',
					active:
						this.$route.path ===
						this.localePath({ path: '/my-jobs' }),
				},
				{
					icon: 'document-duplicate-solid',
					text: 'Applications',
					path: '/jobs/applications',
					active:
						this.$route.path ===
						this.localePath({ path: '/jobs/applications' }),
				},
        {
          icon: 'academic-cap',
          text: 'Bursaries',
          path: '/bursaries',
          active:
              this.$route.path ===
              this.localePath({ path: '/bursaries' }),
        },
				{
					icon: 'book-open-solid',
					text: 'Resources',
					path: '/courses',
					active:
						this.$route.path ===
						this.localePath({ path: '/courses' }),
				},
			];




			if(this.showEventsLink){
				arr.splice(3, 0, {
					icon: 'academic-cap',
					text: 'Events',
					path: '/events',
					active:
						this.$route.path ===
						this.localePath({ path: '/events' }),
				})
			}else{
				arr.push({
					icon: 'save-icon',
					text: 'Saved',
					path: '/saved-jobs',
					active:
						this.$route.path ===
						this.localePath({ path: '/saved-jobs' }),
				})
			}

			arr.push({
				icon: 'trophy',
				text: 'Awards',
				path: '/profile/cv',
				active:
					this.$route.path ===
					this.localePath({ path: '/profile/cv' }) && this.currentTab === 'employability-awards',
			})

			return arr;
		},

		showEventsLink(){
			return this.$store.getters['workshops/getShowWorkshopsLink'];
		},

		...mapGetters({
			universityTheme: 'getUniversityTheme',
			theme: 'getTheme',
		}),

		...mapGetters('cv-profile', {
			currentTab: 'getCurrentTab',
		}),

		courseCollection() {
			return this.$store.getters['courses/getCourses'];
		},

		workshopCollection() {
			return this.$store.getters['workshops/getWorkshops'];
		},

		//Check if we have a course with a created at date after last week date
		newCourses(){
			let oneWeek = this.$dayjs().subtract(1, 'week');
			return this.courseCollection?.data?.filter((course) => this.$dayjs( this.$dayjs(course.created_at)).isAfter(oneWeek)).length > 0 || false;
		},

		newWorkshops() {
			let oneWeek = this.$dayjs().subtract(1, 'week');

			return this.workshopCollection?.data?.filter((workshop) => this.$dayjs(this.$dayjs(workshop.created_at)).isAfter(oneWeek)).length > 0 || false;
		},
	},

	created() {
		this.checkForUnreadNotifications();
	},

	mounted() {
		this.$echo
			.private(`candidates.${this.$auth.user.uuid}.conversations`)
			.listen('.candidate.conversation.updated', () => {
				this.$store.dispatch(
					'conversations/setHasUnreadMessages',
					true,
				);
			});
	},

	beforeDestroy() {
		this.$echo.leave(`candidate.${this.$auth.user.uuid}.conversations`);

		clearTimeout(this.notificationCheckTimer);
	},

	methods: {
		checkForUnreadNotifications() {
			const checkForUnread = () => {
				this.$store.dispatch('notifications/notification/checkForUnread')
					.catch((error) => {
						console.log(error);
					});
			};

			checkForUnread();

			this.notificationCheckTimer = setInterval(checkForUnread, 20000);
		},

		goToPage(page) {
			if (page.includes('saved-jobs')) this.clearFilteredJobs();
			if (page.includes('profile/cv')) {
				this.$store.dispatch(
					'cv-profile/setCurrentTab',
					'employability-awards',
				);
			}
			this.$router.push(this.localePath({ path: page }));
		},

		clearFilteredJobs() {
			let filters = {
				job_type: null,
				location_type: null,
				salary_from: null,
				salary_to: null,
			};

			this.$store.dispatch('jobs/setCursor', null);
			this.$store.dispatch('jobs/setFilters', filters);
			this.$store.dispatch('jobs/setSearch', null);
			this.$store.dispatch('jobs/setFilteredJobs', null);
			this.$store.dispatch('jobs/getFilteredJobs');
		},
	},
};
